window.initVendorShowStock = function() {
  console.log("[initVendorShowStock] Starting vendor show stock script initialization...");

  // Find the toggle button element by its ID
  var toggleButton = document.getElementById("toggle-stock-filter");
  if (toggleButton) {
    console.log("[initVendorShowStock] Toggle button found:", toggleButton);
  } else {
    console.error("[initVendorShowStock] Toggle button not found. Make sure the button is rendered in your HTML.");
    return;
  }

  // Initial filter state: false means no filter applied (show all items)
  var filterActive = false;
  console.log("[initVendorShowStock] Initial filter state set to:", filterActive);

  // Attach click event listener to the toggle button
  toggleButton.addEventListener("click", function() {
    // Toggle the filter state
    filterActive = !filterActive;
    console.log("[initVendorShowStock] Toggle button clicked. New filter state:", filterActive);

    // Get all variant rows that have the ID "collection-list-row"
    var variantRows = document.querySelectorAll('[id="collection-list-row"]');
    console.log("[initVendorShowStock] Found", variantRows.length, "variant rows.");

    // Loop through each variant row to adjust its display based on stock value
    variantRows.forEach(function(row, index) {
      var stockAttr = row.getAttribute('data-in-stock');
      var stock = Number(stockAttr);
      console.log("[initVendorShowStock] Processing row", index, "with data-in-stock:", stockAttr, "parsed as:", stock);

      if (filterActive) {
        // Only show rows with a stock number greater than 0
        if (stock > 0) {
          row.style.display = "";
          console.log("[initVendorShowStock] Row", index, "is in stock. Display set to visible.");
        } else {
          row.style.display = "none";
          console.log("[initVendorShowStock] Row", index, "is out of stock. Hiding row.");
        }
      } else {
        // If filter is off, show all rows
        row.style.display = "";
        console.log("[initVendorShowStock] Filter is off. Row", index, "display set to visible.");
      }
    });

    // Update only the inner text of the span with the "toggle-text" class
    var textSpan = toggleButton.querySelector('.toggle-text');
    if (textSpan) {
      textSpan.textContent = filterActive ? "Show All Items" : "Show In Stock Only";
      console.log("[initVendorShowStock] Button text updated to:", textSpan.textContent);
    } else {
      // Fallback if the text span isn't found
      toggleButton.textContent = filterActive ? "Show All Items" : "Show In Stock Only";
      console.log("[initVendorShowStock] Fallback: Button text updated to:", toggleButton.textContent);
    }
  });
};

// Ensure the DOM is fully loaded before initializing
document.addEventListener('DOMContentLoaded', function() {
  console.log("[DOMContentLoaded] DOM fully loaded. Initializing vendor show stock.");
  window.initVendorShowStock();
});
